module.exports = __webpack_public_path__ + "img/Psych_text05b_knowledge.5893f150.png";